import React from "react";
import {
  Grid,
  TextField,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import { ExtractedContract, SourceValue } from "../../../types/contract";
import { isSourceValue } from "../utils";
import { detailFields, fieldLabels } from "../contractFieldConfig";
import { useContractFieldUtils } from "../useContractFieldUtils";

interface ContractFieldsGridProps {
  selectedContract: ExtractedContract;
  isFieldDisabled: (field: keyof ExtractedContract) => boolean;
  onDetailChange: (field: keyof ExtractedContract, value: string) => void;
}

export const ContractFieldsGrid: React.FC<ContractFieldsGridProps> = ({
  selectedContract,
  isFieldDisabled,
  onDetailChange,
}) => {
  const { getEditableFieldValue, getFieldValue } = useContractFieldUtils();

  return (
    <Grid container spacing={1} sx={{ mt: 1 }}>
      {detailFields.map((field) => (
        <React.Fragment key={field}>
          {/* 建物情報の前に区切りを追加 */}
          {field === "property_address" && (
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>
          )}
          {/* 家主情報の前に区切りを追加 */}
          {field === "owner_name" && (
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            {field === "co_occupant_info" ? (
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#FF7292", fontWeight: "bold" }}
                >
                  {fieldLabels[field]}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ minHeight: "32px", whiteSpace: "pre-wrap" }}
                >
                  {getFieldValue(selectedContract[field])}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  (同居者情報の編集は今後のアップデートで対応予定です)
                </Typography>
              </Box>
            ) : (
              (() => {
                const currentValue = getEditableFieldValue(
                  selectedContract[field],
                );
                return (
                  <TextField
                    label={fieldLabels[field]}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    value={currentValue}
                    placeholder={currentValue === "" ? "N/A" : ""}
                    InputLabelProps={{ shrink: true }}
                    disabled={isFieldDisabled(field)}
                    onChange={(e) => onDetailChange(field, e.target.value)}
                    sx={{
                      "& .MuiInputLabel-root": {
                        color: "#FF7292",
                        fontWeight: "bold",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#FF7292",
                      },
                    }}
                    helperText={`参照元: ${
                      isSourceValue(selectedContract[field])
                        ? (selectedContract[field] as SourceValue)
                            .source_document
                        : "N/A"
                    }`}
                  />
                );
              })()
            )}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};